import type { MercuryFocusArea } from '../../types';

export const isMercuryFocusArea = (entity: any): entity is MercuryFocusArea =>
	entity.__typename === 'MercuryFocusArea';

export const getMercuryFocusAreaLink = (focusArea: MercuryFocusArea): string | null =>
	focusArea?.url ?? null;
